<template>
  <div>
    <public-head :backgroundImage="bg" class="title" subTitle="INVESTOR RELATIONS" title="投资者关系" :show="true" />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: require('../assets/img/InvestorRelations.png')
    }
  },
  mounted() {
    // if (this.$route.query.type) {

    // } else {
    //     this.$router.push({
    //         path: '/news/company'
    //     })
    // }
  }
};
</script>

<style>
.title {
  font-family: Source Han Sans CN;
}
</style>
